<template>
  <WsCard001 
    :to="to"
    :hasTopBar="hasTopBar"
    style="overflow: visible"
    @click="$emit('click',$event)"
  >
    <div class="ws-card__content">
      <slot name="head"/>
      <WsChips001 :value="chips" />
      <WsTitle001
        h4
        bold
        :is-ellipsis2="isEllipsis2"
      >
        {{ title }}
      </WsTitle001>
      <WsChips001 :value="tags" />
      <WsSpec001 :value="spec" />
      <slot name="footer"/>
    </div>
    <div class="ws-card__button mt-10">
      <WsButton001
        v-if="hasBtn"
        width-stretch
        flat-button
        :leading-icon="btnIcon"
        @click.native.prevent="$_btnClick()"
      >
        {{ btnText }}
      </WsButton001>
    </div>
  </WsCard001>
</template>
<script>
export default {
  name: "LlAuditCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    chips: {
      type: Array,
      default() {
        return [];
      },
    },
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
    spec: {
      type: Array,
      default() {
        return [];
      },
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    btnText: {
      type: String,
      default: "",
    },
    btnIcon: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    isEllipsis2: {
      type: Boolean,
      default: true,
    },
    hasTopBar: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    $_btnClick() {
      this.$emit("btn-click");
    },
  },
};
</script>